import { createStyles, MantineTheme, rem } from "@mantine/core";

import { themeGradientBackground } from "../../../utils/mantine/themeGradientBackground.ts";

export const useStyles = createStyles(
  (
    theme: MantineTheme,
    { variant }: { variant: "golden" | "blue" | "green" | "disabled" }
  ) => ({
    wrapper: {
      boxShadow: "0px 2px 19px 0px rgba(55, 65, 82, 0.10)",
      width: "100%",
      height: "100%",
      opacity: variant === "disabled" ? 0.8 : 1,
    },
    pin: {
      width: rem(12),
      height: rem(12),
      flexShrink: 0,
      ...themeGradientBackground(theme, variant),
    },
    label: {
      fontSize: rem(14),
      lineHeight: 1.5,
      textTransform: "capitalize",
      fontWeight: 600,
      color:
        variant === "disabled"
          ? theme.colors.grayIce[0]
          : theme.colors.midnightBlue[0],
    },
    addText: {
      color: theme.colors.dusk[0],
      fontSize: rem(14),
      fontWeight: 500,
      textDecoration: "underline",
      cursor: "pointer",
      whiteSpace: "nowrap",
    },
  })
);
